import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { clearAuth } from "../lib/auth";

const navigation = [
  { label: "Properties", to: "/properties" },
  { label: "Upload", to: "/upload" },
  { label: "Analytics", to: "/analytics" },
  { label: "Broker Admin", to: "/admin/brokers" },
  { label: "Institutional Admin", to: "/admin/institutions" },
] as const;

export function DashboardLayout() {
  const navigate = useNavigate();

  function logout() {
    clearAuth();
    navigate("/login", { replace: true });
  }

  return (
    <div className="min-h-screen bg-slate-50 md:grid md:grid-cols-[16rem_1fr]">
      <aside className="flex border-b border-slate-200 bg-mls-900 px-5 py-6 text-white md:min-h-screen md:flex-col md:border-b-0">
        <NavLink className="flex shrink-0 items-center gap-3" to="/properties">
          <span className="grid size-10 place-items-center rounded-xl bg-white/10 text-sm font-bold text-emerald-200">
            M2
          </span>
          <span>
            <span className="block font-semibold">MLS2</span>
            <span className="block text-xs text-slate-300">Property intelligence</span>
          </span>
        </NavLink>

        <nav
          aria-label="Dashboard navigation"
          className="ml-6 flex gap-2 overflow-x-auto md:ml-0 md:mt-8 md:flex-col"
        >
          {navigation.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [
                  "whitespace-nowrap rounded-lg px-3 py-2 text-sm transition-colors",
                  isActive
                    ? "bg-white text-mls-900"
                    : "text-slate-300 hover:bg-white/10 hover:text-white",
                ].join(" ")
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <button
          className="ml-auto shrink-0 rounded-lg px-3 py-2 text-left text-sm text-slate-300 transition hover:bg-white/10 hover:text-white md:mt-auto md:ml-0"
          type="button"
          onClick={logout}
        >
          Logout
        </button>
      </aside>

      <main className="min-w-0 p-6 md:p-10">
        <Outlet />
      </main>
    </div>
  );
}